import { render, staticRenderFns } from "./correctInfoItem.vue?vue&type=template&id=93bcc65e&scoped=true&"
import script from "./correctInfoItem.vue?vue&type=script&lang=js&"
export * from "./correctInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./correctInfoItem.vue?vue&type=style&index=0&id=93bcc65e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bcc65e",
  null
  
)

export default component.exports